import React from 'react';

export interface PremiumBadgeProps {
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
  inline?: boolean;
}

export const PremiumBadge: React.FC<PremiumBadgeProps> = ({
  size = 'medium',
  showLabel = true,
  inline = false,
}) => {
  const sizeStyles = {
    small: {
      fontSize: '0.7rem',
      padding: '0.2rem 0.5rem',
      iconSize: '0.8rem',
    },
    medium: {
      fontSize: '0.85rem',
      padding: '0.35rem 0.75rem',
      iconSize: '1rem',
    },
    large: {
      fontSize: '1rem',
      padding: '0.5rem 1rem',
      iconSize: '1.2rem',
    },
  };

  const currentSize = sizeStyles[size];

  return (
    <span
      style={{
        ...styles.badge,
        fontSize: currentSize.fontSize,
        padding: currentSize.padding,
        display: inline ? 'inline-flex' : 'flex',
      }}
    >
      <span style={{ fontSize: currentSize.iconSize }}>⭐</span>
      {showLabel && <span style={{ marginLeft: '0.25rem' }}>Premium</span>}
    </span>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    borderRadius: 'var(--radius-md)',
    fontWeight: '700',
    textTransform: 'uppercase',
    boxShadow: '0 2px 8px rgba(245, 158, 11, 0.3)',
    whiteSpace: 'nowrap',
  },
};
